export default __webpack_public_path__ + "files/nitrate_trend_station_data_20years-cc684fa568daa10d5cc6d804a179135a.json";